import './HeroSection.css';
import HeroTitleHexagon from '../../components/HeroTitleHexagon';
import HeroImage from '../../assets/img/hero-image.jpg';
import HeroImage1 from '../../assets/img/orangeBg1.jpg';
import HeroImage3 from '../../assets/img/grayBg.jpg';


const HeroSection = () => {

    return (
        <div className='hero'>
            <img src={HeroImage3} alt='' className='hero-bg-image' />
            <div className='hero-bg-image-border'>
                <HeroTitleHexagon />
                <div className="hero-hexagon-border"></div>
            </div>
        </div>
    );
};

export default HeroSection;
